/* eslint-disable no-invalid-this */

/**
 * Refreshes tokens using the Cognito flow.
 *
 * This function first refreshes the Cognito token via this.cognitoAuthenticator.refreshTokens(),
 * then calls fetchNeonApiTokenAndUser with the Cognito token (and an empty two-factor code).
 *
 * @param {string} [organisationTenantSlug=''] - Organisation slug for multi-tenancy.
 * @param {number} attemptsCount - Number of refresh attempts so far.
 * @returns {Promise<Object>} - Resolves with the authenticated user object.
 */
export function refreshTokens(organisationTenantSlug = '', attemptsCount) {
    return new Promise((resolve, reject) => {
        this.cognitoAuthenticator.refreshTokens()
            .then(cognitoToken => {
                this.fetchNeonApiTokenAndUser(cognitoToken, '', organisationTenantSlug, attemptsCount)
                    .then(user => {
                        this.logger.notice({
                            message: 'Neon-api Refresh token exchange successful (Cognito)',
                            userUuid: user.uuid,
                            component: 'neonAuth'
                        });
                        resolve(user);
                    })
                    .catch(error => {
                        this.logger.error({
                            message: 'Unsuccessful refresh token exchange from neon-api (Cognito)',
                            error,
                            component: 'neonAuth'
                        });
                        reject(error);
                    });
            })
            .catch(error => {
                this.logger.error({
                    message: 'Unsuccessful refresh token response from Cognito',
                    error,
                    component: 'neonAuth'
                });
                reject(error);
            });
    });
}
